/* @ngInject */
export default function ($scope, $stateParams, LayoutService, toastr, $state, Quoting, $window, AuthService, DataTablesService, CSV, FileSaver, PreferencesService) {
	AuthService.redirectIfUnauthorized('view-quoting', 'splash.home');

	$scope.quoteId = $stateParams.quoteId;

	$scope.dtOptions = DataTablesService.configure({
		title:             'Quote',
		toggleableColumns: true,
		buttonsCallback:   (buttons) => {
			return buttons.map((button) => {
				if (button.extend !== 'csv') {
					return {
						...button,
					};
				} else {
					return {
						...button,
						action: (e, dt, node, config) => {
							var data = dt.buttons.exportData();

							const rows = [
								[
									...data.header,
									...Object.keys(
										$scope
											.quote
											.formattedShifts[0]
											.rates,
									)
									         .map((rate) => {
										         return '$' + rate;
									         }),
								],
								...data.body.map((row, index) => {
									const formattedShift = $scope.quote.formattedShifts[index];

									return [
										row[0],
										row[1],
										row[2],
										row[3],
										row[4].replace(/ +(?= )/g, '')
										      .replace(/(\d\d - \d\d:) /g, '')
										      .replace(/( \()/g, '\n('),
										...Object.values(formattedShift.rates),
									];
								}),
							];

							CSV
								.stringify(rows, {
									header:             false,
									fieldSep:           ',',
									decimalSep:         '.',
									addByteOrderMarker: false,
									quoteStrings:       true,
									txtDelim:           '"',
								})
								.then((output) => {
									FileSaver.saveAs(new Blob([output]), `${$scope.quote.title}.csv`);
								})
								.catch((error) => {
									toastr.clear();
									toastr.error('There was an error while exporting to CSV, please try again.', 'Error');
								});
						},
					};
				}
			});
		},
	}, {
		ordering:   false,
		columnDefs: [
			{
				targets: 4,
				visible: false,
			},
		],
	}).options;

	LayoutService.setTitle('Quote');

	LayoutService.getPageHeader()
	             .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-download"></i> Download</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'staff.quoting.root',
			             displayName: 'Quotes',
		             },
		             {
			             route:       `staff.quoting.view({ quoteId: "${$scope.quoteId}" })`,
			             displayName: 'Quote',
		             },
	             ]);

	$scope.loading = true;

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.refresh = () => {
		$scope.loading = true;

		Quoting.one($scope.quoteId)
		       .get({
			       include: 'formattedShifts,enquiry',
		       })
		       .then((quote) => {
			       $scope.quote   = quote;
			       $scope.loading = false;

			       LayoutService.reset();
			       LayoutService.setTitle($scope.quote.title);

			       LayoutService.getPageHeader()
			                    .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-download"></i> Download</button>');

			       LayoutService.getPageHeader()
			                    .setBreadcrumbs([
				                    {
					                    route:       'staff.dashboard',
					                    displayName: 'Dashboard',
				                    },
				                    {
					                    route:       'staff.quoting.root',
					                    displayName: 'Quotes',
				                    },
				                    {
					                    route:       `staff.quoting.view({ quoteId: "${$scope.quoteId}" })`,
					                    displayName: $scope.quote.title,
				                    },
			                    ]);

			       LayoutService.getPageHeader()
			                    .onClicked(() => {
				                    $window.open(`${process.env.API_ENDPOINT}quoting/${$scope.quote.id}/Quote - ${$scope.quote.title}.pdf?token=${AuthService.getToken()}`, '_blank');
			                    });

			       $scope.dtOptions = DataTablesService.configure({
				       title:             $scope.quote.title,
				       toggleableColumns: true,
				       buttonsCallback:   (buttons) => {
					       return buttons.map((button) => {
						       if (button.extend !== 'csv') {
							       return {
								       ...button,
							       };
						       } else {
							       return {
								       ...button,
								       action: (e, dt, node, config) => {
									       var data = dt.buttons.exportData();

									       const rows = [
										       [
											       ...data.header,
											       ...Object.keys(
												       $scope
													       .quote
													       .formattedShifts[0]
													       .rates,
											       )
											                .map((rate) => {
												                return '$' + rate;
											                }),
										       ],
										       ...data.body.map((row, index) => {
											       const formattedShift = $scope.quote.formattedShifts[index];

											       return [
												       row[0],
												       row[1],
												       row[2],
												       row[3],
												       row[4].replace(/ +(?= )/g, '')
												             .replace(/(\d\d - \d\d:) /g, '')
												             .replace(/( \()/g, '\n('),
												       ...Object.values(formattedShift.rates),
											       ];
										       }),
									       ];

									       CSV
									           .stringify(rows, {
									              header:             false,
									              fieldSep:           ',',
									              decimalSep:         '.',
									              addByteOrderMarker: false,
									              quoteStrings:       true,
									              txtDelim:           '"',
									           })
									           .then((output) => {
									              FileSaver.saveAs(new Blob([output]), `${$scope.quote.title}.csv`);
									           })
									           .catch((error) => {
									              toastr.clear();
									              toastr.error('There was an error while exporting to CSV, please try again.', 'Error');
									           });
								       },
							       };
						       }
					       });
				       },
			       }, {
				       ordering:   false,
				       columnDefs: [
					       {
						       targets: 4,
						       visible: false,
					       },
				       ],
			       }).options;
		       })
		       .catch((error) => {
			       toastr.clear();
			       toastr.error('There was an error while loading this quote, please try again.', 'Error');

			       $state.go('staff.quoting.root');

			       $scope.loading = false;
		       });
	};

	LayoutService.getPageHeader()
	             .onClicked(() => {
		             $window.open(`${process.env.API_ENDPOINT}quoting/${$scope.quote.id}/Quote.pdf?token=${AuthService.getToken()}`, '_blank');
	             });

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/quoting/view/controller.js